import { RadioGroupModel } from "@genexus/chameleon-controls-library";
import { GxOption } from "../..";
export type ChCheckboxArray = HTMLChCheckboxElement[] | null;

// map Options to radio model items
export const mapOptionsToRadioModel = (
  options: GxOption[]
): RadioGroupModel => {
  return options.map(option => {
    return {
      caption: option.label,
      disabled: option.disabled,
      value: option.value
    };
  });
};
